export default __webpack_public_path__ + "static/media/chessbase.a7fc4472.webp";